import { z } from 'zod';

export const preferencesSchema = z.object({
  currency: z.enum(['EUR', 'USD', 'GBP']),
  defaultCategory: z.enum([
    'Alimentation',
    'Transport',
    'Hébergement',
    'Bureautique',
    'Restauration',
    'Autre',
  ]),
  reviewNotifications: z.boolean(),
  weeklySummary: z.boolean(),
});

export type Preferences = z.infer<typeof preferencesSchema>;

export const defaultPreferences: Preferences = {
  currency: 'EUR',
  defaultCategory: 'Autre',
  reviewNotifications: true,
  weeklySummary: false,
};
